import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import DrugInteractionsAnalyzeTab from './DrugInteractionsAnalyzeTab';
import DrugInteractionsHistoryTab from './DrugInteractionsHistoryTab';

const DrugInteractionsPanel = ({ onClose, medications, patientUuid }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('quick-check');

  const handleTabChange = (activeKey) => {
    setActiveTab(activeKey);
  };

  const tabItems = [
    {
      key: 'quick-check',
      label: t('drug_interactions.quick_check'),
      children: <DrugInteractionsAnalyzeTab medications={medications} patientUuid={patientUuid} />
    },
    {
      key: 'history',
      label: t('drug_interactions.history'),
      children: <DrugInteractionsHistoryTab />
    }
  ];

  return (
    <Tabs
      activeKey={activeTab}
      onChange={handleTabChange}
      items={tabItems}
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      tabBarStyle={{ marginBottom: 16, padding: '0 16px' }}
    />
  );
};

export default DrugInteractionsPanel; 